import { isValid } from 'date-fns';
import React from 'react';

import SportsFormattedTimeZone from '@swf/sports/components/SportsFormattedTimeZone/SportsFormattedTimeZone';

interface Props {
  eventStartDate: string | number;
  format?: 'short' | 'medium' | 'long';
}

const BetDate: React.FC<Props> = ({ eventStartDate, format = 'long' }) => {
  const eventDate = new Date(eventStartDate);

  if (!isValid(eventDate)) return null;

  return <SportsFormattedTimeZone date={eventStartDate} format={format} withTime />;
};

export default BetDate;
